import React, { FC } from 'react';

import { GRADIENT_INPUT_STYLE } from 'views/OfferDesign/OfferDesign.consts';
import { normalizeGradientColor } from 'views/OfferDesign/OfferDesign.utils';

import AcGradientInput from 'components/AcGradientInput/AcGradientInput';

import { FieldLayout, FIELD_LAYOUT_MAP, GradientFieldConfig, Spacing, SPACING_MAP } from '../FormFields.types';
import { getFormFieldValue } from '../FormFields.utils';

import { useFormFieldsContext } from '../../../context';

interface IFormFieldsGradientRowProps {
  fields: GradientFieldConfig[];
  spacing?: Spacing;
  layout?: FieldLayout;
}

export const FormFieldsGradientRow: FC<IFormFieldsGradientRowProps> = ({
  fields,
  spacing = 'none',
  layout = 'full'
}): React.ReactElement => {
  const { values, getFieldProps, setFieldValue } = useFormFieldsContext();

  return (
    <div className={`flex gap-5 ${SPACING_MAP[spacing]} ${FIELD_LAYOUT_MAP[layout]}`.trim()}>
      {fields.map(({ header, name, fallback, required, dataTestId }) => {
        const fieldProps = getFieldProps(name);
        const testIdPrefix = dataTestId;
        return (
          <div key={name} className={`flex-1 ${GRADIENT_INPUT_STYLE}`}>
            <AcGradientInput
              header={header}
              required={required}
              name={name}
              dataTestId={dataTestId}
              dataTestPopoverId={
                testIdPrefix ? `${testIdPrefix}-popover` : undefined
              }
              dataTestColorOneId={
                testIdPrefix ? `${testIdPrefix}-color-one` : undefined
              }
              dataTestColorTwoId={
                testIdPrefix ? `${testIdPrefix}-color-two` : undefined
              }
              dataTestGradientTypeId={
                testIdPrefix ? `${testIdPrefix}-gradient-type` : undefined
              }
              dataTestGradientDirectionId={
                testIdPrefix ? `${testIdPrefix}-gradient-direction` : undefined
              }
              defaultValue={normalizeGradientColor(getFormFieldValue(values, name), fallback)}
              onChange={fieldProps.onChange}
              onBlur={fieldProps.onBlur}
              setValue={setFieldValue}
            />
          </div>
        );
      })}
    </div>
  );
};
